export enum tabsIds {
  OVERVIEW,
  REGISTRY,
  EMPLOYEES,
  CONTACT_INFO,
}

const tabsList = {
  OVERVIEW: { id: tabsIds.OVERVIEW, label: 'Overview' },
  REGISTRY: { id: tabsIds.REGISTRY, label: 'Registry' },
  EMPLOYEES: { id: tabsIds.EMPLOYEES, label: 'Employees' },
  CONTACT_INFO: { id: tabsIds.CONTACT_INFO, label: 'Contact Info' },
}

export const getTabsList = () => [tabsList.OVERVIEW, tabsList.REGISTRY, tabsList.EMPLOYEES, tabsList.CONTACT_INFO]
